import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div style={{marginBottom: '15px'}}>
              <h3 style={{marginBottom: '5px', color: 'white'}}><span style={{color: '#FF6B35'}}>F</span>-IT Score</h3>
              <p style={{fontSize: '14px', margin: 0}}>from <a href="https://www.p2bs.org" target="_blank" rel="noopener noreferrer" style={{color: '#FF6B35'}}>P2bS</a></p>
            </div>
            <div>
              <h3 style={{marginBottom: '5px', color: 'white'}}><span style={{color: '#3366CC'}}>F</span>-YOU Score</h3>
              <p style={{fontSize: '14px', margin: 0}}>from <a href="http://www.ankerandmarsh.com" target="_blank" rel="noopener noreferrer" style={{color: '#3366CC'}}>Anker & Marsh</a></p>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Get Started</h4>
            <ul>
              <li><Link to="/demo">Request Demo</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/why-it-works">Why It Works</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: <a href="mailto:hello@f-itscore.com" style={{color: '#FF6B35'}}>hello@f-itscore.com</a></p>
            <p>Part of the P2bS family</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} F-IT Score. All rights reserved.</p>
          <p style={{fontSize: '12px', marginTop: '8px', opacity: '0.8'}}>F-IT® is a registered trademark of P2bS · F-YOU® is a registered trademark of Anker & Marsh</p>
          <p>A P2bS Initiative</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
